import React from 'react';
import {
  documentsCompanyContactSectionTitle,
  documentsCompanyContactServicesTitle,
  documentsCompanyContactServicesContent,
  documentsCompanyContactSACTitle,
  documentsCompanyContactSACContent,
  documentsCompanyContactombudsmanTitle,
  documentsCompanyContactombudsmanContent,
  documentsCompanyContactCASTitle,
  documentsCompanyContactCASContent,
} from '../../utils/constants';
import * as S from './styled';

const CompanyContacts = () => (
  <S.CompanyContactsSection
    displayGrid
    gridCol={2}
    title={documentsCompanyContactSectionTitle}
  >
    <S.ContactTitledContent
      text
      title={documentsCompanyContactServicesTitle}
      content={documentsCompanyContactServicesContent}
    />
    <S.ContactTitledContent
      text
      title={documentsCompanyContactSACTitle}
      content={documentsCompanyContactSACContent}
    />
    <S.ContactTitledContent
      text
      title={documentsCompanyContactCASTitle}
      content={documentsCompanyContactCASContent}
    />
    <S.ContactTitledContent
      text
      title={documentsCompanyContactombudsmanTitle}
      content={documentsCompanyContactombudsmanContent}
    />
  </S.CompanyContactsSection>
);

export default CompanyContacts;
